export default __webpack_public_path__ + "static/media/img-03-mini.c8119976.png";